export default {
   replaceAll: function (str, search, replacement) {
      if(str) {
         return str.replace(new RegExp(search, 'g'), replacement);
      }
      return str;
   },
   getLines: function(lineStr) {
      if(lineStr)
         return lineStr.match(/[^\r\n]+/g);
      return [];
   },
   isEmptyOrNull: function(str) {
      return !str || str === "";
   },
   isArrayEquals: function(a, b) {
      return Array.isArray(a) &&
          Array.isArray(b) &&
          a.length === b.length &&
          a.every((val, index) => val === b[index]);
   },
   formatI18nText(key, dictionary) {
      let i18nText = dictionary[key];
      if(i18nText) {
         return i18nText;
      }
      return key;
   },
   formatI18nParams: function(text, index, param) {
      if(!text)
      {
         return text;
      }
      else
      {
         return this.replaceAll(text, '__' + index + '__', param);
      }
   }
}